"use client";

export const getHostUrl = () => {
    if (typeof process.env.NEXT_PUBLIC_API_BASE_URL !== 'undefined') {
        return process.env.NEXT_PUBLIC_API_BASE_URL;
    }

    let url = 'https://api.sons.co.uk/';
    if (typeof window !== "undefined") {
        const windowHref = window.location.href;
        if (windowHref.includes('sons-staging')) {
            url = 'https://sons-staging-api.tickledchilli.co.uk/';
        } else if (windowHref.includes('sons.local') || windowHref.includes('localhost')) {
            url = 'https://api.sons.local/';
        } else if (windowHref.includes('sons-dev')) {
            url = 'https://sons-dev-api.tickledchilli.co.uk/';
        } else if (windowHref.includes('local.sons')) {
            url = 'https://local.sons.api/';
        }

    }
    return url;
}

export const getBaseUrl = () => {

    let url = 'https://sons.co.uk/';

    if (typeof window !== "undefined") {
        const windowHref = window.location.href;
        if (windowHref.includes('sons-staging')) {
            url = 'https://sons-staging-shopify.tickledchilli.co.uk/';
        } else if (windowHref.includes('sons-dev') || windowHref.includes('local')) {
            url = 'https://sons-dev-shopify.tickledchilli.co.uk/';
        } else if (windowHref.includes('sonshaar.de') || windowHref.includes('/de/')) {
            url = 'https://sonshaar.de/';
        }
    }

    return url;
}

const  getProtocolAndHostnameRoot = () => {
    const { protocol, hostname } = window.location;

    // Split the hostname by dots
    const parts = hostname.split('.');

    // Handle localhost or IP addresses
    if (parts.length < 2) {
        return `${protocol}//${hostname}`;
    }

    // Extract the root domain (e.g., example.com from sub.example.com)
    const rootDomain = parts.slice(-2).join('.');

    return `${protocol}//${rootDomain}`;
}
